import React from 'react'
import { Tooltip } from 'antd'
import { Company } from '../../../../types/company/Company'

export interface StatusInfo {
  icon: React.ReactNode
  label?: string
}

interface CompanyListProps {
  companies: Company[]
  selectedId: string
  onSelect: (id: string) => void
  getStatus?: (companyId: string) => StatusInfo | undefined
}

const CompanyList: React.FC<CompanyListProps> = ({ companies, selectedId, onSelect, getStatus }) => {
  return (
    <div>
      {companies.map(company => {
        const statusInfo = getStatus?.(company.id)

        return (
          <button
            key={company.id}
            type="button"
            onClick={() => onSelect(company.id)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 8,
              width: '100%',
              textAlign: 'left',
              border: 'none',
              padding: '7px 12px',
              fontSize: 14,
              cursor: 'pointer',
              borderLeft: `3px solid ${company.id === selectedId ? '#2a78d6' : 'transparent'}`,
              background: company.id === selectedId ? '#eef4fc' : 'transparent'
            }}
          >
            <span>{company.name}</span>
            {statusInfo &&
              (statusInfo.label ? (
                <Tooltip title={statusInfo.label}>
                  <span style={{ display: 'inline-flex', fontSize: 13 }}>{statusInfo.icon}</span>
                </Tooltip>
              ) : (
                <span style={{ display: 'inline-flex', fontSize: 13 }}>{statusInfo.icon}</span>
              ))}
          </button>
        )
      })}
    </div>
  )
}

export default CompanyList
